import React from 'react'
import {DateTime} from '../time/DateTime'
import {P415Client, P415FileApi} from '../client/P415Client'
import {CardSection} from './common/Card'
import {BuildingInput} from "./BuildingInput";
import {DownloadButton} from "./common/SubmitButton";
import {DownloadIcon} from "./icons/Icons";
import {SingleTable} from "./common/Tables";
import fileDownload from "js-file-download";
import {GridColDef} from "@mui/x-data-grid";
import Button from "@mui/material/Button";


export interface P415FilesSentToEdfProps {
    p415Files: P415FileApi[]
    buildings: { id: number, name: string }[]
    selectedBuilding: { id: number, name: string } | undefined
    setSelectedBuilding: (building: { id: number, name: string }) => void

    p415Client: P415Client

    className?: string
    disableVirtualizationForTesting?: boolean
}


export const P415FilesSentToEdf: React.FC<P415FilesSentToEdfProps> = ({
                                                                          p415Files, buildings,
                                                                          selectedBuilding, setSelectedBuilding,
                                                                          p415Client,
                                                                          className,
                                                                          disableVirtualizationForTesting
}: P415FilesSentToEdfProps) => {

    async function downloadFile(file: P415FileApi): Promise<void> {
        const result = await p415Client.retrieveFile(file)
        const outcome = result.map(content => fileDownload(content, file.simpleFilename))
        return void outcome
    }

    async function downloadFilesZip(): Promise<void> {
        const result = await p415Client.retrieveFiles(selectedBuilding)
        const outcome = result.map(content => fileDownload(content, 'p415-files.zip'))
        return void outcome
    }

    function toRowData(file: P415FileApi){
        return ({
            queryableDataId: file.fileName,
            file: file,
            filename: file.simpleFilename,
            dateTime: DateTime.fromISO(file.dateTime).toFormat('yyyy-MM-dd HH:mm'),
            fileType: file.fileType,
            mpan: file.mpan,
        })
    }

    const columns: GridColDef[] = [
        {field: 'dateTime', headerClassName: 'table-column-header', headerName: '(London) Time sent', flex: 1},
        {field: 'mpan', headerClassName: 'table-column-header', headerName: 'MPAN', flex: 1},
        {field: 'fileType', headerClassName: 'table-column-header', headerName: 'File Type', flex: 1},
        {
            field: "download",
            headerName: "Download",
            sortable: false,
            renderCell: ({ row: { file } }) =>
                <Button data-testid={`download-${file.fileName}`} onClick={() => downloadFile(file)} >
                    <DownloadIcon/>
                </Button>,
        }
    ]
    return (
        <CardSection className={className} header="P415 Files Sent to EDF" data-testid="card-p415-files-sent-to-edf">

            <div className="d-flex align-items-center gap-3 mb-3">
                <div className="flex-grow-1">
                    <BuildingInput buildings={buildings}
                                   onBuildingChange={setSelectedBuilding}
                                   building={selectedBuilding}/></div>
                <DownloadButton text='Download as zip' onSubmit={() => downloadFilesZip()} dataTestId={`download-files-zip`} startIcon={<DownloadIcon/>}/>
            </div>

            <SingleTable dataTestId='table-p415-files-sent-to-edf'
                         disableVirtualization={disableVirtualizationForTesting}
                         data={p415Files.map(p415File => toRowData(p415File))}
                         pageSize={10}
                         checkboxSelection={false}
                         customColumns={columns}
                         enableAdditionalControls={false}
                         localeText={{MuiTablePagination: {labelDisplayedRows: ({from, to, count}) => `${from}–${to} of ${count > 9999 ? 'many' : count}`}}}
            />

        </CardSection>
    )
}
